import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";

const SummaryContainer = styled("div")({
	display: "flex",
	flexWrap: "wrap",
});

const cardStyles = {
	width: { md: 185, sm: 185, xs: "100%" },
	minHeight: "5.3rem",
	backgroundColor: "#002564",
	margin: "0.5rem",
	color: "#4a5568",
	cursor: "pointer",
	"&:hover": {
		boxShadow:
			"0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%)",
	},
};

const cardContentStyles = {
	padding: "0.5rem",
	height: "100%",
	display: "flex",
	flexDirection: "column",
	justifyContent: "space-between",
	"&:last-child": {
		padding: "0.5rem",
	},
};

const RequestSummaryCards = ({ summaryLoading, requestSummary, title }) => {
	return (
		<Box>
			<Typography
				variant="h6"
				component="div"
				sx={{ textTransform: "capitalize", margin: "0.5rem" }}
			>
				{title}
			</Typography>
			<SummaryContainer>
				<Card
					sx={{
						...cardStyles,
						backgroundColor: "#fffaf0",
						color: "#4a5568;",
					}}
					elevation={0}
				>
					<CardContent
						sx={{
							...cardContentStyles,
						}}
					>
						<Typography
							variant="p"
							sx={{ mb: 1.5, width: "70%", color: "#718096" }}
							component="div"
						>
							Pending Initator Approval
						</Typography>
						<Typography align="right" variant="h4">
							{summaryLoading ? (
								<CircularProgress size="1.5rem" />
							) : (
								requestSummary.totalInitiatorPending || 0
							)}
						</Typography>
					</CardContent>
				</Card>
				<Card
					sx={{
						...cardStyles,
						backgroundColor: "#fff5f5",
					}}
					elevation={0}
				>
					<CardContent
						sx={{
							...cardContentStyles,
						}}
					>
						<Typography
							variant="p"
							sx={{ mb: 1.5, width: "70%", color: "#718096" }}
							component="div"
						>
							Declined
						</Typography>
						<Typography align="right" variant="h4">
							{summaryLoading ? (
								<CircularProgress size="1.5rem" />
							) : (
								requestSummary.totalRejected || 0
							)}
						</Typography>
					</CardContent>
				</Card>
				<Card
					sx={{
						...cardStyles,
						backgroundColor: "#f0fff4",
					}}
					elevation={0}
				>
					<CardContent
						sx={{
							...cardContentStyles,
						}}
					>
						<Typography
							variant="p"
							sx={{ mb: 1.5, width: "70%", color: "#718096" }}
							component="div"
						>
							Approved By Initiator
						</Typography>
						<Typography align="right" variant="h4">
							{summaryLoading ? (
								<CircularProgress size="1.5rem" />
							) : (
								requestSummary.totalInitiatorApproved || 0
							)}
						</Typography>
					</CardContent>
				</Card>
				<Card
					sx={{
						...cardStyles,
						backgroundColor: "#f0fff4",
					}}
					elevation={0}
				>
					<CardContent
						sx={{
							...cardContentStyles,
						}}
					>
						<Typography
							variant="p"
							sx={{ mb: 1.5, width: "70%", color: "#718096" }}
							component="div"
						>
							Approved By Authorizer
						</Typography>
						<Typography align="right" variant="h4">
							{summaryLoading ? (
								<CircularProgress size="1.5rem" />
							) : (
								requestSummary.totalAuthorizerApproved || 0
							)}
						</Typography>
					</CardContent>
				</Card>
				<Card
					sx={{
						...cardStyles,
						backgroundColor: "#e2e8f0",
					}}
					elevation={0}
				>
					<CardContent
						sx={{
							...cardContentStyles,
						}}
					>
						<Typography
							variant="p"
							sx={{ mb: 1.5, width: "70%", color: "#718096" }}
							component="div"
						>
							Total
						</Typography>
						<Typography align="right" variant="h4">
							{summaryLoading ? (
								<CircularProgress size="1.5rem" />
							) : (
								requestSummary.totalRequests || 0
							)}
						</Typography>
					</CardContent>
				</Card>
			</SummaryContainer>
		</Box>
	);
};

export default RequestSummaryCards;
